import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

import { FormToolsService, MainConfig, LocaleDataService } from "@atenea-cms";
import { HomeSliderFormService } from "../shared";

@Component({
  selector: "home-slider-slide-form",
  templateUrl: "./home-slider-slide-form.component.html",
  styleUrls: ["./home-slider-slide-form.component.scss"],
})
export class HomeSliderSlideFormComponent {
  @Input() form: FormGroup;

  backgroundHorizontalPositions: Array<Object> = [];
  backgroundVerticalPositions: Array<Object> = [];
  contentPositions: Array<Object> = [];
  textColorOptions: Array<Object> = [];
  textBackgroundOptions: Array<Object> = [];
  config: any = {};

  constructor(
    public fb: FormBuilder,
    public ft: FormToolsService,
    public formService: HomeSliderFormService,
    public mainConfig: MainConfig,
    private localeService: LocaleDataService
  ) {
    this.config = this.mainConfig.modules.home;

    this.textColorOptions = [
      { value: "light", label: "Claro" },
      { value: "dark", label: "Oscuro" },
    ];

    this.textBackgroundOptions = [
      { value: "none", label: "Ninguno" },
      { value: "light", label: "Claro" },
      { value: "dark", label: "Oscuro" },
    ];

    this.backgroundHorizontalPositions = [
      { value: "left", label: "Izquierda" },
      { value: "right", label: "Derecha" },
      { value: "center", label: "Centro" },
    ];

    this.backgroundVerticalPositions = [
      { value: "top", label: "Arriba" },
      { value: "bottom", label: "Abajo" },
      { value: "center", label: "Centro" },
    ];

    this.contentPositions = [
      { value: "top", label: "Arriba" },
      { value: "right", label: "Derecha" },
      { value: "bottom", label: "Abajo" },
      { value: "left", label: "Izquierda" },
      { value: "center", label: "Centro" },
    ];
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/home-slider-slide-form/home-slider-slide-form.component.ts